import * as styles from "../../../shared/flexboxgrid.css";
export default function getClass(s) {
  return styles && styles[s] ? styles[s] : s;
}